import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
    FaSeedling,
    FaHandsHelping,
    FaFlask,
    FaChartLine
} from "react-icons/fa";

const journeySteps = [
    {
        year: "Foundation",
        icon: <FaSeedling />,
        title: "Built with a Purpose",
        text: "Hindustan Agro Life was founded with a clear goal — to support Indian farmers with safe, effective, and practical agricultural solutions that work in real field conditions.",
    },
    {
        year: "Early Years",
        icon: <FaHandsHelping />,
        title: "Learning from Farmers",
        text: "By working closely with farmers and dealers, we understood soil challenges, crop needs, and the importance of affordability and reliability.",
    },
    {
        year: "Growth Phase",
        icon: <FaFlask />,
        title: "Innovation & Expansion",
        text: "Continuous research, field trials, and product refinement helped us expand our portfolio while maintaining eco-friendly and responsible practices.",
    },
    {
        year: "Today & Beyond",
        icon: <FaChartLine />,
        title: "A Trusted Agricultural Partner",
        text: "Today, Hindustan Agro Life continues its journey with the same farmer-first mindset, focused on sustainable growth and long-term agricultural progress.",
    },
];

const OurStory = () => {
    return (
        <section className="section our-story-section">
            <Container>

                {/* Section Heading */}
                <div className="section-title fade-up">
                    <h2>Our Story & Journey</h2>
                    <p>
                        A journey shaped by farmer trust, field experience, and a commitment
                        to responsible agricultural growth.
                    </p>
                </div>

                <Row>
                    {journeySteps.map((step, index) => (
                        <Col lg={6} className="mb-4 fade-up" key={index}>
                            <div className="story-card">

                                <div className="story-header">
                                    <div className="story-icon">{step.icon}</div>
                                    <span className="story-year">{step.year}</span>
                                </div>

                                <h4>{step.title}</h4>
                                <p>{step.text}</p>

                            </div>
                        </Col>
                    ))}
                </Row>

            </Container>
        </section>
    );
};

export default OurStory;
